export const getTranslations = t => {
  return {
    printDiagrams: t("kf.myList.parts.partviewer.printDiagrams"),
    printAllText: t("kf.myList.parts.partviewer.printAllText"),
    printSelectedText: t("kf.myList.parts.partviewer.printSelectedText"),
    mailBody: t("kf.partViewer.emailBody"),
    description: t("kf.orderDetails.label.viewPartsDiagram"),
    mailSubjectTextOne: t("kf.partViewer.emailSubject"),
    mailSubjectTextTwo: t("kf.orderDetails.label.viewPartsDiagram"),
    discontinuedText: t("kf.partViewer.gridView.discontinuedText"),
    addingCartText: t("kf.partViewer.gridView.cart.addingCartText"),
    addedCartText: t("kf.partViewer.gridView.cart.addedCartText"),
    outOfStockText: t("kf.compare.label.outOfStock"),
    addToCart: t("kf.cart.label.addToCart"),
    colorFinish: t("kf.pdp.label.colorOrFinish"),
    addedText: t("kf.partViewer.gridView.cart.addedText"),
    notifyText: t("kf.partViewer.NotifyMe.cart.notifyText"),
    notifySuccessText: t("kf.partViewer.NotifyMe.cart.notifySuccessText"),
    notifyEmailText: t("kf.partViewer.NotifyMe.cart.notifyEmailText"),
    successText: t("kf.partViewer.NotifyMe.cart.successText"),
    notifyOutofStockText: t("kf.partViewer.NotifyMe.cart.notifyOutofStockText"),
    notifyButtonText: t("kf.partViewer.NotifyMe.cart.notifyButtonText"),
    inventoryTextVal: inventory =>
      t("kf.partViewer.addtocart.cart.inventoryText", { inventory }),
    cartNotificationText: (number, category) =>
      t("kf.partViewer.gridView.cart.Notification", { number, category }),
    errorText: t("kf.partViewer.pageError.errorText"),
    queryText: t("kf.partViewer.pageError.queryText"),
    contactUsButton: t("kf.partViewer.pageError.contactUsButton"),
    viewreplacement: t("kf.partViewer.replacementPart.viewreplacement"),
    replacing: t("kf.partViewer.replacementPart.replacing"),
    replacedby: t("kf.partViewer.replacementPart.replacedby"),
    partname: t("kf.partViewer.replacementPart.partname"),
    partnumber: t("kf.partViewer.replacementPart.partnumber"),
  }
}
